import { ErrorPage } from '~/components/ErrorPage';

function LoginError({ error }: { error: Error }) {
  return <ErrorPage type="noAccessPage" message={error.message} />;
}

LoginError.displayName = 'LoginError';

export { LoginError };
